export default {"src":"/_next/static/media/knc.cb8f0e3d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};